<template>
    <div>
        <Banner></Banner>
        <BoxesArea></BoxesArea>
<!--        <Services></Services>-->
<!--        <ServicesArea></ServicesArea>-->
        <Features></Features>
<!--        <Team></Team>-->
<!--        <Funfacts></Funfacts>-->
<!--        <Works></Works>-->
<!--        <Pricing></Pricing>-->
<!--        <Feedback></Feedback>-->
<!---->
<!---->
<!--        <Partner></Partner>-->
<!--        <Blog></Blog>-->
    </div>
</template>

<script>
import Banner from './it-startup/Banner';
import BoxesArea from './it-startup/BoxesArea';
// import Services from './it-startup/Services';
// import ServicesArea from './it-startup/ServicesArea';
import Features from './it-startup/Features';
// import Team from './it-startup/Team';
// import Funfacts from './it-startup/Funfacts';
// import Works from './it-startup/Works';
// import Pricing from './it-startup/Pricing';
// import Feedback from './it-startup/Feedback';
// import Partner from './it-startup/Partner';
// import Blog from './it-startup/Blog';
export default {
    name: 'Home',
    components: {
        Banner,
        BoxesArea,
        // Services,
        // ServicesArea,
        Features,
        // Team,
        // Funfacts,
        // Works,
        // Pricing,
        // Feedback,
        // Partner,
        // Blog
    }
}
</script>
